import {actionChangeTabDesign} from '../components/step2/context/SelectedVariantContext/action'
import preview3DGif from '../assets/images/preview3d.gif'
import preview2DGif from '../assets/images/preview2d.gif'
import {MockupType} from './index'

const initStep = {
    target: '#init_tour',
    placement: 'center',
    title: 'Welcome to the Merchize Product Creator 🎨 🚀',
    description:
        'Take a quick tour of the powerful new features we’ve added for designing and creating amazing products.  💡 ✨',
    next: (dispatch) => {
        dispatch(actionChangeTabDesign('product'))
    },
}

const firstStep = {
    target: '#tab_product_v3',
    placement: 'left',
    title: '📦 Check Product Info in a Click',
    description:
        'See everything you need at a glance — sizes, colors, production cost, design tips, and even a downloadable template.',
    isMulti: true,
    els: ['#tab_product_v3', '#right-sidebar'],
    offset: 0,
    bridgeThreshold: 0,
    next: (dispatch) => {
        dispatch(actionChangeTabDesign(''))
    },
}

const switchSidesStep = {
    target: '#switch_sides',
    placement: 'top',
    title: '👀 Preview the Final Look',
    description: (
        <p>
            Upload your design to the specific side you want to print on.
            <br />
            <strong>Example:</strong> to customize the sleeves, upload your artwork to the Sleeve area.
            <br />
            Use All areas view to see the full layout and visualize how pieces come together on the product.
        </p>
    ),
    offset: 8,
}
const headerNextBtnStep = {
    target: '#header_next_btn',
    placement: 'bottom',
    title: '💾 Save Your Awesome Product',
    description: 'Love your design? Hit the button and get ready to show it off!',
    popoverOffset: {x: -160, y: 0},
    arrowProps: {offset: {x: 190, y: 0}},
    closeBtnProps: {hidden: true},
    nextBtnProps: {
        children: 'Got it',
    },
    elRadius: 8,
}

export const noDesignTemplateSteps = [
    initStep,
    firstStep,
    {
        target: '#tab_add_image_v3',
        placement: 'left',
        title: '🛠 Upload Your Artwork',
        description:
            'This mockup only supports one design layer which will be used directly for printing your product.',
    },
    {
        target: '#header_next_btn',
        placement: 'bottom',
        title: '💾 Save Your Awesome Product',
        description: (
            <p>
                Love your design? Hit the button and get ready to show it off!
                <br />
                ⚠️ <strong>Note</strong>: This product does not support 3D preview. Please make sure your design is
                ready to print before saving.
            </p>
        ),
        popoverOffset: {x: -100, y: 0},
        arrowProps: {offset: {x: 190, y: 0}},
        elRadius: 8,
    },
]

export const template3DSteps = [
    initStep,
    firstStep,
    {
        target: '#design_tools',
        placement: 'left',
        title: '🛠 Play with Powerful Design Tools',
        description: 'Add images, text, or graphics and customize them just the way you like.',
    },
    {
        target: '#preview_live_artwork_container',
        placement: 'right',
        className: 'StepTourContent__Preview3d',
        title: '👀 Preview the Final Look',
        description: (
            <div className={'StepTourContent__Preview3dDescription'}>
                <picture>
                    <img src={preview3DGif} alt={''} />
                </picture>
                <p>
                    <strong>⚠️Important:</strong>
                    <ul>
                        <li>The 3D mockup only shows the area inside the green dashed line.</li>
                        <li>
                            If you want your design to cover the full product size, make sure your artwork extends all
                            the way to the gray background area on the template.
                        </li>
                    </ul>
                </p>
            </div>
        ),
    },
    headerNextBtnStep,
]

export const template2D = [
    initStep,
    firstStep,
    {
        target: '#design_tools',
        placement: 'left',
        title: '🛠 Play with Powerful Design Tools',
        description: 'Add images, text, or graphics and customize them just the way you like.',
    },
    // switchSidesStep,
    {
        target: '#preview_live_artwork_container',
        placement: 'right',
        className: 'StepTourContent__Preview3d',
        title: '👀 Preview the Final Look',
        description: (
            <div className={'StepTourContent__Preview3dDescription'}>
                <picture>
                    <img src={preview2DGif} alt={''} />
                </picture>
                <p>
                    <strong>⚠️Important:</strong>
                    <ul>
                        <li>Easily create your design and see instant updates on the product mockup as you edit. The preview is displayed on a size L mockup — for other sizes, your design will be automatically scaled to fit proportionally.</li>
                    </ul>
                </p>
            </div>
        ),
    },
    headerNextBtnStep,
]

export const splitLayoutSteps = template2D

export const combineLayout = [
    initStep,
    firstStep,
    {
        target: '#design_tools',
        placement: 'left',
        title: '🛠 Play with Powerful Design Tools',
        description: 'Add images, text, or graphics and customize them just the way you like.',
        offset: 0,
    },
    {
        target: '#test-canvas',
        placement: 'right',
        title: 'Understand This Product’s Template',
        // description: 'Add images, text, or graphics and customize them just the way you like.',
        description: (
            <p>
                Template is a print-ready that combines all product parts into one.
                <br />
                👉<strong> Recommended:</strong>
                <br />
                Upload one full artwork that covers the entire template to ensure seamless printing across all product
                areas.
            </p>
        ),
        canvas: '#test-canvas',
        canvasRegions: [{x: 610, y: 105, w: 620, h: 620}],
    },
    headerNextBtnStep,
]

export const draftMockupTypeSteps = [
    initStep,
    firstStep,
    {
        target: '#tab_add_image_v3',
        placement: 'left',
        title: '🛠  Play with Powerful Design Tools',
        description: 'Add images, text, or graphics and customize them just the way you like.',
    },
    {
        target: '#header_next_btn',
        placement: 'bottom',
        title: '💾 Save Your Awesome Product',
        description: (
            <p>
                Love your design? Hit the button and get ready to show it off!
                <br />
                ⚠️ <strong>Note</strong>: This product does not support 3D preview. Please make sure your design is
                placed correctly on the template and ready to print before saving.
            </p>
        ),
        popoverOffset: {x: -160, y: 0},
        arrowProps: {offset: {x: 190, y: 0}},
        elRadius: 8,
    },
]

export const stepsGuide = {
    [MockupType.REGULAR_NO_TEMPLATE]: noDesignTemplateSteps,
    [MockupType.COMBINE_LAYOUT]: combineLayout,
    [MockupType.TYPE_2D]: template2D,
    [MockupType.PREVIEW_3D]: template3DSteps,
    [MockupType.REGULAR_HAS_TEMPLATE]: draftMockupTypeSteps,
    [MockupType.SPLIT_LAYOUT]: splitLayoutSteps,
}
